<template>
  <div>
    <div v-if="$auth.policies['view-period-list']" class="pa-4">
      <div class="px-4 mb-6 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            :headline="`Chi tiết kỳ lương ${$options.filters.convertFullDate(period.title)}`"
            :link="[
              { text: 'Tài chính', href: '#' },
              { text: 'Kỳ lương', href: '#' },
              { text: `Chi tiết kỳ lương ${$options.filters.convertFullDate(period.title)}` }
            ]"
          />
        </div>

        <div class="d-flex justify-space-between">
          <v-btn class="mr-4" color="primary" @click="$refs['import-excel-salary'].openDialog()">
            NHẬP EXCEL
          </v-btn>
          <ExportExcel />
          <div v-if="period.status === 'finished'">
            <v-btn v-if="$auth.policies['summary-period']" class="search-button ml-6" @click="openDialog" outlined>
              <v-icon>mdi-wallet-plus</v-icon> &nbsp; Tổng kết lại
            </v-btn>
          </div>
        </div>
      </div>
      <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
        <PeriodInfo />
      </v-card>
      <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
        <PeriodReportTable />
      </v-card>
      <PeriodResummaryDialog ref="reSummary" />
      <ImportExcelDialog ref="import-excel-salary" />
    </div>
    <div v-else>
      <Page403 />
    </div>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import Page403 from '@/views/Page403.vue'
import PeriodInfo from './period-detail/PeriodInfo.vue'
import PeriodReportTable from './period-detail/report-table/index.vue'
import ExportExcel from '@/modules/tuitionFee/detail-period/action/ExportExcel.vue'
import { mapActions, mapGetters } from 'vuex'
import PeriodResummaryDialog from './period-detail/PeriodResummaryDialog.vue'
import ImportExcelDialog from './period-detail/ImportExcelDialog.vue'

export default {
  components: {
    Breadcrumbs,
    PeriodInfo,
    PeriodReportTable,
    PeriodResummaryDialog,
    ExportExcel,
    ImportExcelDialog,
    Page403
  },
  async created() {
    await this.fetchPeriod(this.$route.params.id)
  },
  computed: {
    ...mapGetters({
      period: 'salaryPeriod/period'
    })
  },
  methods: {
    ...mapActions('salaryPeriod', ['fetchPeriod']),
    openDialog() {
      this.$refs.reSummary.openDialog()
    }
  }
}
</script>
